import LogoRedemptionPartner from './LogoRedemptionPartner'

const LogoQantasBusinessRewards = (props) => (
  <LogoRedemptionPartner {...props} viewBox="0 0 480 120">
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="401.17"
        y1="117.23"
        x2="321.14"
        y2="0.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#be0000" />
        <stop offset="0.39" stopColor="#de0000" />
        <stop offset="0.77" stopColor="#f60000" />
        <stop offset="1" stopColor="red" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="379.06"
        y1="64.46"
        x2="380.14"
        y2="52.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.65" stopColor="#fff" stopOpacity="0" />
        <stop offset="0.69" stopColor="#ededed" stopOpacity="0.23" />
        <stop offset="0.76" stopColor="#d7d7d7" stopOpacity="0.5" />
        <stop offset="0.81" stopColor="#c6c6c6" stopOpacity="0.72" />
        <stop offset="0.87" stopColor="#b9b9b9" stopOpacity="0.87" />
        <stop offset="0.91" stopColor="#b2b2b2" stopOpacity="0.97" />
        <stop offset="0.95" stopColor="#afafaf" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="363.21"
        y1="97.01"
        x2="415.11"
        y2="97.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" stopOpacity="0" />
        <stop offset="0.07" stopColor="#f3f3f3" stopOpacity="0.15" />
        <stop offset="0.21" stopColor="#dedede" stopOpacity="0.41" />
        <stop offset="0.35" stopColor="#cdcdcd" stopOpacity="0.62" />
        <stop offset="0.49" stopColor="silver" stopOpacity="0.79" />
        <stop offset="0.63" stopColor="#b7b7b7" stopOpacity="0.91" />
        <stop offset="0.77" stopColor="#b1b1b1" stopOpacity="0.98" />
        <stop offset="0.9" stopColor="#afafaf" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-4"
        x1="298.38"
        y1="43.17"
        x2="356.4"
        y2="43.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopColor="#fff" stopOpacity="0" />
        <stop offset="0.36" stopColor="#f7f7f7" stopOpacity="0.11" />
        <stop offset="0.58" stopColor="#e1e1e1" stopOpacity="0.38" />
        <stop offset="0.88" stopColor="#bebebe" stopOpacity="0.82" />
        <stop offset="1" stopColor="#afafaf" />
      </linearGradient>
    </defs>
    {/* Qantas Tail */}
    <path
      fill="url(#linear-gradient)"
      d="M341.47,117.66h120L365.31,21.09A68.73,68.73,0,0,0,317,.67H296.88l1.5,3.93L305,22.08Z"
    />
    {/* Kangaroo */}
    <path
      fill="#fff"
      d="M305,22.08c13.14,22.43,47.61,24.8,51.36,59.68a3.19,3.19,0,0,0,2.68,2.81,118.54,118.54,0,0,1,56,24.76h0a.55.55,0,0,0,.37.14.63.63,0,0,0,.42-.17.61.61,0,0,0,0-.85A119.43,119.43,0,0,0,374.1,80l-4.86-2a6.66,6.66,0,0,1-4.16-6.34c.27-10.42,24.92-8.3,27.42-13.31l.43-.87a46.2,46.2,0,0,0-17.75-9.42c-.06.25-.22,1.47,1.13,3.67,1.47,2.39-1.6,6.2-6.08,2.09l-.38-.34C336.55,23,311.58,38.85,298.38,4.6Z"
    />
    {/* Kangaroo Shading */}
    <path
      fill="url(#linear-gradient-2)"
      d="M385.13,57a10.41,10.41,0,0,1-8.82-5.19A2.59,2.59,0,0,1,374,55.71V64c3.59-1,7.69-1.68,11.13-2.4Z"
    />
    <path
      fill="url(#linear-gradient-3)"
      d="M363.21,85.29a118.59,118.59,0,0,1,51.9,24C380.23,79.53,364.34,84.92,363.21,85.29Z"
    />
    <path
      fill="url(#linear-gradient-4)"
      d="M312.06,23.64h0c-5.42-3.86-10-9.51-13.68-19L305,22.08c13.14,22.43,47.61,24.8,51.36,59.67C352.61,37.24,333.06,43.89,312.06,23.64Z"
    />
    {/* Business Rewards Text */}
    <path
      fill="#323232"
      d="M283.8,13.15V11.69c0-7-5-11.69-12.22-11.69-7.48,0-12.29,4.94-12.29,11.08S263.1,20.3,268,22.64L273,25c3.67,1.74,6.74,3.21,6.74,8.28,0,4.08-2.87,7.68-8.21,7.68s-8.15-3.14-8.15-7.14v-2h-4.94v1.73c0,7,5.54,11.69,13.16,11.69,8.08,0,13-5.21,13-12.49,0-7.61-5.14-10.15-10.09-12.49l-4.94-2.33c-3.07-1.47-5.47-2.94-5.47-7.15,0-3.47,2.67-6.48,7.34-6.48s7.55,3,7.55,7.15v1.73Zm-38.47,0V11.69c0-7-5-11.69-12.22-11.69-7.47,0-12.28,4.94-12.28,11.08s3.8,9.22,8.75,11.56L234.52,25c3.67,1.74,6.74,3.21,6.74,8.28,0,4.08-2.87,7.68-8.21,7.68s-8.15-3.14-8.15-7.14v-2H220v1.73c0,7,5.54,11.69,13.15,11.69,8.08,0,13-5.21,13-12.49,0-7.61-5.15-10.15-10.09-12.49l-4.94-2.33c-3.07-1.47-5.47-2.94-5.47-7.15,0-3.47,2.67-6.48,7.34-6.48s7.55,3,7.55,7.15v1.73ZM205.87,24.37V19.9H189.58V5.21h17.76V.67H184.5V44.54h23.37V40H189.58V24.37ZM167.94.67h-4.67V33.45L146.84.67h-4.47V44.54H147V11.22l16.69,33.32h4.21ZM125.8.67h-5.07V44.54h5.07ZM105.44,13.15V11.69c0-7-5-11.69-12.22-11.69C85.74,0,80.93,4.94,80.93,11.08s3.81,9.22,8.75,11.56L94.62,25c3.67,1.74,6.74,3.21,6.74,8.28,0,4.08-2.87,7.68-8.21,7.68S85,37.79,85,33.79v-2H80.06v1.73c0,7,5.54,11.69,13.16,11.69,8.08,0,13-5.21,13-12.49,0-7.61-5.14-10.15-10.08-12.49l-5-2.33c-3.07-1.47-5.47-2.94-5.47-7.15,0-3.47,2.67-6.48,7.34-6.48s7.55,3,7.55,7.15v1.73ZM61,.67v31c0,5.14-2.87,9-7.81,9s-7.88-3.88-7.88-9V.67H40.2V31.52c0,8.41,5.27,13.69,12.95,13.69S66,39.93,66,31.52V.67ZM13.09,24.24c4.87,0,7.88,3.2,7.88,8s-3.14,7.88-8.35,7.88H5.07V24.24ZM11.69,5.07c5.2,0,8.34,2.81,8.34,7.15C20,17,17,19.9,12.15,19.9H5.07V5.07ZM13,44.54c8,0,13.23-4.74,13.23-12.09,0-4.94-2.07-8.34-6.95-10.61v-.07c4.14-2.34,5.94-5.48,5.94-9.88C25.17,5.07,19.7.67,11.89.67H0V44.54ZM283.8,86.27V84.8c0-7-5-11.68-12.22-11.68-7.48,0-12.29,4.94-12.29,11.08s3.81,9.22,8.75,11.55L273,98.09c3.67,1.74,6.74,3.21,6.74,8.28,0,4.07-2.87,7.68-8.21,7.68s-8.15-3.14-8.15-7.14v-2h-4.94v1.74c0,7,5.54,11.68,13.16,11.68,8.08,0,13-5.2,13-12.48,0-7.62-5.14-10.15-10.09-12.49L269.57,91c-3.07-1.47-5.47-2.94-5.47-7.14,0-3.47,2.67-6.48,7.34-6.48s7.55,3,7.55,7.15v1.73Zm-52.09-8c5.41,0,8.42,4.08,8.42,9.69v15.42c0,5.61-3,9.69-8.42,9.69H224V78.32Zm0-4.54H219v43.88h12.75c8.22,0,13.49-5.55,13.49-14.36V88.14c0-8.81-5.27-14.36-13.49-14.36m-48.15,43.88v-17.3h6.21a20.84,20.84,0,0,0,2.34-.13l6.68,17.43h5.54l-7.21-18.57c4.41-1.93,7.28-6.34,7.28-12.22,0-7.94-6.08-13.09-14.49-13.09H178.49v43.88Zm6.08-39.4c5.88,0,9.55,3.4,9.55,8.61,0,5.48-3.67,9.08-9.55,9.08h-6.08V78.26Zm-29.38,39.4h5.27L152.84,73.78h-5.21l-12.55,43.88h5l2.67-10.09h14.76Zm-4-14.49H144l6.08-22.58Zm-42.87,14.49H118l8.94-43.88h-4.87l-6.34,34.33L109,73.78h-4.68l-6.54,34.33L91.41,73.78H86.33l9,43.88H100l6.61-34.53ZM72.84,97.49V93H56.55V78.32H74.31V73.78H51.47v43.88H74.85v-4.54H56.55V97.49ZM16.08,117.66v-17.3h6.21a21,21,0,0,0,2.34-.13l6.67,17.43h5.55L29.64,99.09c4.4-1.93,7.27-6.34,7.27-12.22,0-7.94-6.07-13.09-14.49-13.09H11v43.88Zm6.08-39.4c5.87,0,9.55,3.4,9.55,8.61C31.71,92.35,28,96,22.16,96H16.08V78.26Z"
    />
  </LogoRedemptionPartner>
)

export default LogoQantasBusinessRewards
